// src/app/services/google-maps-api.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleApiService {
  private apiKey: string = environment.GOOGLE_API_KEY;
  private apiLoaded: Promise<void>;

  constructor() {
    this.apiLoaded = new Promise<void>((resolve) => {
      if (window.google && window.google.maps) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve();
      };
      document.body.appendChild(script);
    });
  }

  loadApi(): Promise<void> {
    return this.apiLoaded;
  }
}
